import React, { useEffect } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getUserData } from 'utils';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';

const TreatmentAreaModal = ({
  isOpen,
  onClose,
  type = 'add',
  initialData = {},
  fetchAgain,
}) => {
  const userData = getUserData();
  const clinic_id = userData.clinic_id ?? null;

  const [isSubmitting, setIsSubmitting] = React.useState(false);


  const validationSchema = Yup.object().shape({
    treatmentArea: Yup.string().required('Treatment area is required'),
  });

  // const fetchTreatmentArea = async () => {
  //   try {
  //     const response = await createAPIEndPoint('treatment_areas/').fetchById(
  //       initialData.id,
  //     );
  //     console.log('🚀 ~ fetchteabt ~ response:', response.data);
  //     console.log(response.data || []);
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Error fetching patient');
  //   }
  // };

  // useEffect(() => {
  //   if (initialData.id) {
  //     fetchTreatmentArea();
  //   }
  // }, [initialData.id, isOpen]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      treatmentArea: initialData?.treatment_area || '',
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true)
      const payload = {
        clinic_id,
        treatment_area: values.treatmentArea,
      };

      try {
        if (initialData.id) {
          await createAPIEndPoint('update_treatment_area/').update(
            initialData.id,
            payload,
          );
          toast.success('Treatment area updated successfully!');
        } else {
          await createAPIEndPoint('create_treatment_area').create(payload);
          toast.success('Treatment area added successfully!');
          resetForm();
        }
        fetchAgain();
        onClose();
      } catch (error) {
        toast.error(
          error?.response?.data?.error ||
          'An error occurred while processing the treatment area.',
        );
      } finally {
        setIsSubmitting(false); // ✅ Stop loading
      }
    },
  });
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        borderRadius="16px"
        pb="16px"
        maxWidth={{ base: '90%', md: '448px' }}
        maxH="90vh"
        overflowY="auto"
      >
        <ModalHeader color="brand.500">
          {type === 'edit' ? 'Edit Treatment Area' : 'Add Treatment Area'}
        </ModalHeader>
        <ModalCloseButton />
          <form onSubmit={formik.handleSubmit}>
        <ModalBody maxHeight="70vh" overflowY="auto" pb={2}>
            {['treatmentArea'].map((field, index) => (
              <FormControl
                key={index}
                isInvalid={formik.touched[field] && formik.errors[field]}
                mb={2}
              >
                <FormLabel mb={0} textTransform="capitalize">
                  {field
                    .replace(/([A-Z])/g, ' $1')
                    .trim()
                    .toLowerCase()}
                </FormLabel>

                <Input
                  name={field}
                  placeholder={`Enter ${field
                    .replace(/([A-Z])/g, ' $1')
                    .trim()
                    .toLowerCase()}`}
                  variant="auth"
                  fontSize="sm"
                  fontWeight="500"
                  value={formik.values[field]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <Text color="red.500" fontSize="sm">
                    {formik.errors[field]}
                  </Text>
                )}
              </FormControl>
            ))}
        </ModalBody>
        <ModalFooter pt={0}>
          <Button type="submit" colorScheme="brand" w="100%" mt={4} isLoading={isSubmitting} >
            {type === 'edit' ? 'Edit Treatment Area' : 'Add Treatment Area'}
          </Button>
        </ModalFooter>
          </form>
      </ModalContent>
    </Modal>
  );
};

export default TreatmentAreaModal;
